export default "__VITE_ASSET__e6233b02__"